module.exports = __webpack_public_path__ + "static/img/ikonaNotatnikDisabled-ON.32de94be.png";